import { useReactiveVar } from '@apollo/client';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';
import { getDensityConfig } from 'src/helpers/densityConfig';
import widthToBreakPoint from 'src/helpers/widthToBreakpoint';
import { akomiMediaCardGridVar } from 'src/store/akomiMediaCardGridVar';
import { AkomiMediaCardRouter } from '../AkomiMediaCardRouter';
import type { GridViewProps, MediaCardBreakPoints } from '../types';

type BreakpointKey = keyof MediaCardBreakPoints;

const GalleryOnlyView: React.FC<GridViewProps> = ({ assetsData, mediaCardBreakPoints, windowWidth }) => {
  const { density } = useReactiveVar(akomiMediaCardGridVar);
  const densityConfig = getDensityConfig(density);
  const breakpointKey = widthToBreakPoint(windowWidth) as BreakpointKey;
  const breakpointValue = mediaCardBreakPoints[breakpointKey];
  const itemsPerRow = 12 / (breakpointValue as number);

  return (
    <Grid container={true} wrap="wrap" direction="row" alignItems="flex-start">
      {assetsData.map((item, index) => {
        const isLastInRow = (index + 1) % itemsPerRow === 0 || index === assetsData.length - 1;

        if (isLastInRow) {
          return (
            <React.Fragment key={item.id}>
              <Grid item {...mediaCardBreakPoints}>
                <Box display="flex" alignItems="flex-start" justifyContent="center" margin={densityConfig.cardMargin}>
                  <AkomiMediaCardRouter item={item} index={index} />
                </Box>
              </Grid>
            </React.Fragment>
          );
        }

        return (
          <Grid key={item.id} item {...mediaCardBreakPoints}>
            <Box display="flex" alignItems="flex-start" justifyContent="center" margin={densityConfig.cardMargin}>
              <AkomiMediaCardRouter item={item} index={index} />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default GalleryOnlyView;
